import { useTranslation } from 'react-i18next';

export default function AuroraTrustSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('aurora.trust.title')}
          </h2>
          <p className="text-xl text-gray-300">
            {t('aurora.trust.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-gradient-to-br from-blue-900 to-purple-900 rounded-xl p-8 border border-blue-700">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
              <i className="ri-shield-check-line text-3xl text-blue-400 mr-3"></i>
              {t('aurora.trust.features.title')}
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-lock-line text-green-400 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="text-white font-semibold">{t('aurora.trust.features.confidentiality')}</p>
                  <p className="text-gray-300 text-sm">{t('aurora.trust.features.confidentiality.desc')}</p>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-shield-star-line text-green-400 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="text-white font-semibold">{t('aurora.trust.features.risk')}</p>
                  <p className="text-gray-300 text-sm">{t('aurora.trust.features.risk.desc')}</p>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-eye-off-line text-green-400 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="text-white font-semibold">{t('aurora.trust.features.privacy')}</p>
                  <p className="text-gray-300 text-sm">{t('aurora.trust.features.privacy.desc')}</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-gray-900 rounded-xl p-8 border border-gray-700">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
              <i className="ri-bank-line text-3xl text-gray-400 mr-3"></i>
              {t('aurora.trust.bank.title')}
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-alert-line text-red-400 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="text-white font-semibold">{t('aurora.trust.bank.lowConfidentiality')}</p>
                  <p className="text-gray-300 text-sm">{t('aurora.trust.bank.lowConfidentiality.desc')}</p>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-error-warning-line text-red-400 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="text-white font-semibold">{t('aurora.trust.bank.freezeRisk')}</p>
                  <p className="text-gray-300 text-sm">{t('aurora.trust.bank.freezeRisk.desc')}</p>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-eye-line text-red-400 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="text-white font-semibold">{t('aurora.trust.bank.limitedPrivacy')}</p>
                  <p className="text-gray-300 text-sm">{t('aurora.trust.bank.limitedPrivacy.desc')}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* ライセンス情報 */}
        <div className="bg-gradient-to-r from-purple-900 to-blue-900 rounded-xl p-8 border border-purple-700">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">
            <i className="ri-award-line text-3xl text-yellow-400 mr-3"></i>
            {t('aurora.trust.licenses.title')}
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-gray-900/50 rounded-lg p-6 text-center">
              <i className="ri-bank-card-line text-4xl text-purple-400 mb-3"></i>
              <p className="text-white font-semibold mb-2">MSO</p>
              <p className="text-gray-300 text-sm">Money Service Operator</p>
            </div>
            <div className="bg-gray-900/50 rounded-lg p-6 text-center">
              <i className="ri-building-line text-4xl text-blue-400 mb-3"></i>
              <p className="text-white font-semibold mb-2">TCSP</p>
              <p className="text-gray-300 text-sm">Trust or Company Service Provider</p>
            </div>
            <div className="bg-gray-900/50 rounded-lg p-6 text-center">
              <i className="ri-money-dollar-circle-line text-4xl text-green-400 mb-3"></i>
              <p className="text-white font-semibold mb-2">EMI</p>
              <p className="text-gray-300 text-sm">Electronic Money Institution</p>
            </div>
            <div className="bg-gray-900/50 rounded-lg p-6 text-center">
              <i className="ri-bit-coin-line text-4xl text-yellow-400 mb-3"></i>
              <p className="text-white font-semibold mb-2">Crypto Licence</p>
              <p className="text-gray-300 text-sm">{t('aurora.trust.licenses.title')}</p>
            </div>
            <div className="bg-gray-900/50 rounded-lg p-6 text-center">
              <i className="ri-exchange-dollar-line text-4xl text-pink-400 mb-3"></i>
              <p className="text-white font-semibold mb-2">MSB</p>
              <p className="text-gray-300 text-sm">Money Service Business</p>
            </div>
            <div className="bg-gray-900/50 rounded-lg p-6 text-center">
              <i className="ri-smartphone-line text-4xl text-cyan-400 mb-3"></i>
              <p className="text-white font-semibold mb-2">Digital Banking</p>
              <p className="text-gray-300 text-sm">Digital Banking License</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}